import {useEffect, useMemo} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {changeFilters, readFilters, writeFilters} from './performanceUtils';

/**
 * The report's filters live in the URL, so a link, a refresh, a drill-down
 * and the back button all keep them.
 *
 * A URL that arrives without dates is rewritten once with the dates actually
 * used, so what is on screen is always what the link says.
 */
export const usePerformanceFilters = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const filters = useMemo(
    () => readFilters(location.search),
    [location.search],
  );
  const search = writeFilters(filters);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.get('from') || !params.get('to')) {
      navigate({pathname: location.pathname, search}, {replace: true});
    }
  }, [location.pathname, location.search, navigate, search]);

  const update = patch =>
    navigate({
      pathname: location.pathname,
      search: writeFilters(changeFilters(filters, patch)),
    });

  return {filters, update, search};
};
